module.exports = __webpack_public_path__ + "img/db_tiny.63ae26ae.png";